import { tourStep } from './tourRegistry';

export const bandaMensajesSteps = [
  tourStep(
    'mensajes-header',
    'Mensajes',
    'Conversaciones con cofradías y entidades. El punto verde indica que la conexión en tiempo real está activa.',
  ),
  tourStep(
    'mensajes-buscar',
    'Buscar un chat',
    'Filtra por el nombre de la entidad o del evento.',
  ),
  tourStep(
    'mensajes-tabs',
    'Activos, finalizados y cancelados',
    'Separa los tratos en curso de los que ya se celebraron o se anularon.',
  ),
  tourStep(
    'mensajes-chat',
    'La conversación',
    'Aquí se escribe, se adjunta y, cuando hay acuerdo, se confirma. En el móvil, entra en un chat de la lista para verlo.',
    'left',
  ),
];
